export default __webpack_public_path__ + "static/Provide-61cb063344472edc93f37d1e65829d25.webp";